import React from "react";
import { Row, Col, Avatar } from "antd";



const PartyMemberAvatar = ({ photo, name, surname, fullName }) => {
    return (
        <>
            <Row gutter={24} className="text-left">
                <Col span={1}>
                    {name === "" && surname === "" && photo === "" && (
                        <Avatar 
                            style={{ color: "#B821B3", fontSize: "13px", fontWeight: "600", backgroundColor: "#b821b329" }}
                        >
                            A
                        </Avatar>
                    )}
                    {name !== "" && surname !== "" && photo === "" && (
                        <Avatar 
                            style={{ color: "#B821B3", fontSize: "13px", fontWeight: "600", backgroundColor: "#b821b329" }}
                        >
                            {name.toString().charAt(0) + surname.toString().charAt(0)}
                        </Avatar>
                    )}
                    {photo !== "" && (
                        <>
                            <Avatar 
                                src={photo} 
                                style={{ color: "#B821B3", fontSize: "13px", fontWeight: "600", backgroundColor: "#b821b329" }}
                            >
                                {name.toString().toUpperCase().charAt(0) + surname.toString().toUpperCase().charAt(0)}
                            </Avatar>
                        </>
                    )}
                </Col>
                <Col span={20} className="w-100" style={{ marginLeft: "10px" }}>
                    <div className="w-100 text-left ml-2" style={{ marginTop: "5px" }}>
                        <span style={{ fontSize: '14px', fontWeight: "bold" }}>{fullName}</span>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default PartyMemberAvatar;
